import React from 'react';
import Button from '@Components/Button';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
// eslint-disable-next-line import/no-named-as-default
import StructureOptionsContainer from '@Containers/StructureOptions/StructureOptionsContainer';
// eslint-disable-next-line import/no-named-as-default
import Dropdown from '@Components/Popup/Dropdown';

const BATCH_STRUCTURE_UID = 'batch-modal';

function BatchModalContent(props) {
  const {
    search,
    searchContext,
    listOfContexts,
    batchFile,
    structures,
    setCurrentStructureOptions,
    setOverwriteOptions,
    overwriteOptions,
  } = props;

  const onSearch = (context) => {
    search(context);
  };

  const onOverwriteOptionsChange = (e) => {
    setOverwriteOptions(e.target.checked);
  };

  const getContexts = () =>
    listOfContexts &&
    listOfContexts.map((context) => (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <div className="batch-modal__dropdown_item" key={context.displayName} onClick={() => onSearch(context)}>
        {context.displayName}
      </div>
    ));

  const getStructureOptions = () => (
    <StructureOptionsContainer id={BATCH_STRUCTURE_UID} onCurrentOptionsChange={setCurrentStructureOptions} />
  );

  return (
    <div className="batch-modal__content">
      <div className="batch-modal__content_wrapper">
        <div className="batch-modal__content_title">{`Search for File "${batchFile.filename}" with ${batchFile.validQueriesCount} queries has been loaded`}</div>
        <div className="batch-modal__content_buttons">
          <Dropdown content={getContexts} className="batch-modal__dropdown">
            {({ toggle }) => (
              <>
                <Button
                  disabled={!batchFile.validQueriesCount}
                  buttonConfig={{
                    type: 'primary',
                    size: 'sm',
                    label: searchContext ? `Search ${searchContext.displayName}` : 'Search',
                    e2eName: 'batch-modal-search',
                  }}
                  iconConfig={{
                    name: 'chevron-right',
                    size: 'xs',
                  }}
                  onClick={() => {
                    if (!searchContext) {
                      toggle();
                      return;
                    }
                    onSearch(searchContext);
                  }}
                />
                <Button
                  buttonConfig={{
                    type: 'primary',
                    size: 'sm',
                    e2eName: 'batch-modal-dropdown',
                    ariaLabel: `Select search context`,
                  }}
                  iconConfig={{
                    name: 'chevron-down',
                    size: 'xs',
                  }}
                  onClick={toggle}
                />
              </>
            )}
          </Dropdown>
        </div>
      </div>
      {structures && structures.length ? (
        <div className="batch-modal__content_wrapper batch-modal__content_optionsWrapper">
          {overwriteOptions && (
            <Dropdown content={getStructureOptions} horizontalAlignment="left" className="batch-modal__optionsDropdown">
              {({ toggle }) => (
                <Button
                  buttonConfig={{
                    type: 'link',
                    size: 'sm',
                    label: 'Options',
                    e2eName: 'batch-modal-options-dropdown',
                  }}
                  iconConfig={{
                    name: 'chevron-down',
                    size: 'xs',
                  }}
                  onClick={toggle}
                />
              )}
            </Dropdown>
          )}
          <Checkbox
            className="batch-modal__checkbox"
            checked={overwriteOptions}
            onChange={onOverwriteOptionsChange}
            label={overwriteOptions ? '' : 'Overwrite existing options'}
          />
        </div>
      ) : null}
    </div>
  );
}

BatchModalContent.propTypes = {
  search: PropTypes.func.isRequired,
  searchContext: PropTypes.shape({ displayName: PropTypes.string }),
  listOfContexts: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
    })
  ),
  batchFile: PropTypes.shape({ filename: PropTypes.string, validQueriesCount: PropTypes.number }),
  structures: PropTypes.array,
  setCurrentStructureOptions: PropTypes.func.isRequired,
  setOverwriteOptions: PropTypes.func.isRequired,
  overwriteOptions: PropTypes.bool,
};

export default BatchModalContent;
